import {
  getServiceLabelLines,
  type LabelEmployee,
  type ServiceLabelLine
} from '@washday/utilities';
import type { IOrder } from '../interfaces/Order';
import { getOrderByIdV2 } from './order.service';
import { getStoreAssignableStaffV2 } from './store.service';

export type ServiceLabelSnapshot = { order: IOrder; lines: ServiceLabelLine[] };

/** Always fetches; printing assignments must not reuse cached order or staff data. */
export async function fetchServiceLabelSnapshot(
  orderId: string,
  storeId: string,
  labels: { unassigned?: string; unavailable?: string; service?: string } = {}
): Promise<ServiceLabelSnapshot> {
  if (!orderId || !storeId) throw new Error('Missing label order/store scope');
  const response = await getOrderByIdV2(orderId, { fetchSection: 'true' });
  const order = (response as unknown as { data?: { data?: IOrder } })?.data?.data;
  const currentStoreId =
    typeof order?.createdIn === 'string' ? order.createdIn : order?.createdIn?._id;
  if (!order || order._id !== orderId || currentStoreId !== storeId) {
    throw new Error('Label order does not match store scope');
  }
  const staffResponse = await getStoreAssignableStaffV2(storeId, 'appendAdmin=true');
  const staff = staffResponse?.data?.staffs as LabelEmployee[] | undefined;
  if (!Array.isArray(staff)) throw new Error('Label staff response is unavailable');
  const lines = getServiceLabelLines(order, staff, labels);
  const unavailable = lines.filter((line) => line.employeeState === 'unavailable');
  if (unavailable.length > 0) {
    console.warn('Service label employee unavailable', {
      orderId,
      storeId,
      lineKeys: unavailable.map((line) => line.key)
    });
  }
  return { order, lines };
}
